export const getTitle = (vehicle) =>
  vehicle?.vehicle?.vehicleModel &&
  `${vehicle?.vehicle?.vehicleModel?.makeName} ${vehicle?.vehicle?.vehicleModel?.name} ${vehicle?.vehicle?.derivative}`;

export const getShortTitle = (vehicle) =>
  vehicle?.vehicle?.vehicleModel &&
  `${vehicle?.vehicle?.vehicleModel?.makeName} ${vehicle?.vehicle?.vehicleModel?.name}`;
